import React, { useState } from 'react';
import { Plus, CornerDownLeft, Mic } from 'lucide-react';
import TextareaAutosize from 'react-textarea-autosize';

function MyComponent() {
  return (
    <TextareaAutosize
      minRows={2}
      maxRows={8}
      className="form-control"
      placeholder="Tape ton message..."
    />
  );
}


interface ChatInputProps {
  onSendMessage: (message: string) => void;
  textAfterInput?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, textAfterInput = true }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <div
      className="px-3 px-md-4 pt-2 pt-md-4 pb-3 pb-md-4"
    >
      <div className="mx-auto" style={{ maxWidth: '768px' }}>
        <form onSubmit={handleSubmit} className="position-relative">
          <div
            className="d-flex align-items-center  shadow-sm p-3"
            style={{ backgroundColor: '#303030', borderRadius: "25px" }}
          >
            <div className='d-flex flex-column w-100'>
              <div className='w-100'>
                <TextareaAutosize
                  rows={1}
                  className="form-control border-0 p-1 me-2"
                  style={{
                    resize: 'none',
                    background: 'transparent',
                    color: '#d1d5db',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingLeft: "-50px",

                  }}
                  placeholder="Poser une question..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSubmit(e);
                    }
                  }}
                />
              </div>

              <div className='w-100 d-flex justify-content-between'>

                <div className='d-flex'>
                  {/* <button
                    type="button"
                    className="btn btn-sm p-1 bg-transparent border-0"
                    style={{ color: '#d1d5db' }}
                  >
                    <Plus size={20} />
                  </button> */}
                </div>

                <div className='d-flex'>
                  {/* <button
                    type="button"
                    className="btn btn-sm p-1 bg-transparent border-0"
                    style={{ color: '#d1d5db' }}
                  >
                    <Mic size={20} />
                  </button> */}

                  <button
                    type="submit"
                    disabled={!message.trim()}
                    className="btn btn-sm p-1 bg-transparent border-0"
                    style={{ color: message.trim() ? '#ffffff' : '#6c757d' }}
                  >
                    <CornerDownLeft size={20} />
                  </button>
                </div>

              </div>

            </div>

          </div>

          {textAfterInput && (
            <p className="text-center small mt-2 mb-0" style={{ color: '#a1a1aa' }}>
              Famla peut faire des erreurs. Envisagez de vérifier les informations importantes.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ChatInput;
